import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import useGlobalContext from "hooks/globalData";
import{ AutocompleteWithQuery } from "@knowfully/ui.common";
import { AutocompleteWithQueryProps } from "@knowfully/ui.common/components/AutocompleteWithQuery";
import {
  CatalogFiltersRequest,
  GenericSkuFilterModel,
} from "services/organizationPortalClient";
import { SkuAvailabilityId } from "types/commonTypes";
import { Grid } from "@mui/material";
import contextStore from "stores/contextStore";

export type SelectGenericFilterProps = {
  typeId: string;
  labelKey: string;
  gridSize: number;
  skuAvailabilityIds?: SkuAvailabilityId[];
} & Omit<
  AutocompleteWithQueryProps<GenericSkuFilterModel>,
  "fetchedData" | "failMessage" | "labelField" | "multiple"
>;

export default function SelectGenericFilter({
  typeId,
  labelKey,
  gridSize,
  skuAvailabilityIds,
  ...rest
}: SelectGenericFilterProps) {
  const { formatMessage: t } = useIntl();
  const { catalogFilterService } = useGlobalContext();
  const { organization } = contextStore.useState();

  const data = useQuery(
    ["getFilters", organization?.id, typeId, ...(skuAvailabilityIds ?? [])],
    () =>
      catalogFilterService.getFilters(
        CatalogFiltersRequest.fromJS({
          skuAvailabilityIds,
          typeId,
        })
      )
  );

  if (data.isFetched && (data?.data?.data?.length ?? 0) < 2) {
    return null;
  }

  return (
    <Grid item xs={12} sm={12} md={gridSize}>
      <AutocompleteWithQuery
        {...rest}
        size="small"
        labelField="value"
        fetchedData={data}
        label={t({ id: labelKey })}
        failMessage={t({ id: "fetchError" })}
      />
    </Grid>
  );
}
